import { Home } from './Home';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

const mapStateToProps = (state: any) => ({
  isLoggedIn: state.signin.success
});

export default connect(mapStateToProps)(Home);
